import * as token from "@universityofmaryland/web-token-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { trapFocus } from "@universityofmaryland/web-utilities-library/accessibility";
const createModal = ({
  content,
  isHidden,
  context,
  onHide
}) => {
  const body = document.body;
  const html = document.documentElement;
  let eventReference = null;
  let accessibiltyEventReference = null;
  let scrollPosition = 0;
  const backgroundBuilder = new ElementBuilder().withClassName("modal-screen-container-background").withStyles({
    element: {
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      padding: `${token.spacing.xl} ${token.spacing.md}`,
      width: "100%",
      height: "100%",
      [`@media (${token.media.queries.tablet.min})`]: {
        padding: "10vh 10vw"
      }
    }
  }).withChildIf(!!content, content);
  const containerBuilder = new ElementBuilder().withClassName("modal-screen-container").withStyles({
    element: {
      display: "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 999999
    }
  }).withChild(backgroundBuilder);
  const container = containerBuilder.getElement();
  const show = () => {
    scrollPosition = window.scrollY;
    container.style.display = "block";
    body.style.position = "fixed";
    body.style.top = `-${scrollPosition}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.overflow = "hidden";
    body.style.height = "100%";
    html.style.overflow = "hidden";
    html.style.height = "100%";
    eventReference = container.addEventListener("click", (event) => {
      const target = event.target;
      if (target === container) hide();
    });
    accessibiltyEventReference = trapFocus({
      element: container,
      action: hide,
      shadowDomContext: context || null
    });
    if (context) context.dispatchEvent(new CustomEvent("modal:show", { bubbles: true, composed: true }));
    setTimeout(() => {
      if (content) content.focus();
    }, 100);
  };
  const hide = () => {
    body.style.position = "";
    body.style.top = "";
    body.style.left = "";
    body.style.right = "";
    body.style.overflow = "visible";
    body.style.height = "inherit";
    html.style.overflow = "visible";
    html.style.height = "inherit";
    container.style.display = "none";
    window.scrollTo(0, scrollPosition);
    if (accessibiltyEventReference) accessibiltyEventReference();
    if (eventReference) eventReference.removeEventListener("click", () => hide());
    if (onHide) onHide();
    if (context) context.dispatchEvent(new CustomEvent("modal:hide", { bubbles: true, composed: true }));
    setTimeout(() => {
      if (context) {
        const firstItem = context.querySelector("button, a");
        firstItem?.focus();
      }
    }, 100);
  };
  if (isHidden) container.style.display = "none";
  return containerBuilder.withEvents({ show, hide }).build();
};
export {
  createModal
};
//# sourceMappingURL=modal.js.map
